import { render, staticRenderFns } from "./my-alpitour.vue?vue&type=template&id=b77aecd6"
import script from "./my-alpitour.vue?vue&type=script&lang=js"
export * from "./my-alpitour.vue?vue&type=script&lang=js"
import style0 from "./my-alpitour.vue?vue&type=style&index=0&id=b77aecd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports